document.addEventListener("DOMContentLoaded", function () {
  const enquiryDropdown = document.querySelector('select[name="contact[type-of-enquiry]"]');
  const productSearchBlock = document.querySelector('.product-search');
  const fileUploadBlock = document.querySelector('.fileupload');
  const calendarBlock = document.querySelector('.calendar');

  function toggleWarrantyFields() {
    const showFields = enquiryDropdown.value === "Warranty Claim";

    productSearchBlock.style.display = showFields ? "block" : "none";
    fileUploadBlock.style.display = showFields ? "block" : "none";
    calendarBlock.style.display = showFields ? "block" : "none";
  }

  // Initial check
  toggleWarrantyFields();

  // Watch for changes
  enquiryDropdown.addEventListener("change", toggleWarrantyFields);
});
